var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-13 0 512 512.00101",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m471.839844 0h-456.78125c-8.316406 0-15.058594 6.742188-15.058594 15.0625v481.875c0 8.320312 6.742188 15.0625 15.058594 15.0625h456.78125c8.316406 0 15.058594-6.742188 15.058594-15.0625v-481.875c0-8.320312-6.742188-15.0625-15.058594-15.0625zm0 0",
    fill: "#97d85d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m471.871094 10.085938h-223.65625v501.914062h223.65625c8.300781 0 15.03125-6.609375 15.03125-14.765625v-472.382813c-.003906-8.15625-6.730469-14.765624-15.03125-14.765624zm0 0",
    fill: "#71b22d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m471.8125 161.867188h-455.789062c-8.332032 0-15.089844 6.753906-15.089844 15.089843v174.140625h485.96875v-174.140625c-.003906-8.335937-6.757813-15.089843-15.089844-15.089843zm0 0",
    fill: "#fc4f4f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m471.8125 0h-455.789062c-8.332032 0-15.089844 6.140625-15.089844 13.71875v158.324219h485.96875v-158.324219c-.003906-7.578125-6.757813-13.71875-15.089844-13.71875zm0 0",
    fill: "#4a60e5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd561"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m112.472656 380.847656h-51.304687c-8.332031 0-15.085938 6.757813-15.085938 15.089844v73.21875c0 8.335938 6.753907 15.089844 15.085938 15.089844h51.304687c8.332032 0 15.089844-6.753906 15.089844-15.089844v-73.21875c0-8.332031-6.757812-15.089844-15.089844-15.089844zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.472656 209.871094h-51.304687c-8.332031 0-15.085938 6.753906-15.085938 15.089844v73.21875c0 8.335937 6.753907 15.089843 15.085938 15.089843h51.304687c8.332032 0 15.089844-6.753906 15.089844-15.089843v-73.21875c0-8.335938-6.757812-15.089844-15.089844-15.089844zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.472656 33.863281h-51.304687c-8.332031 0-15.085938 6.753907-15.085938 15.089844v73.21875c0 8.332031 6.753907 15.089844 15.085938 15.089844h51.304687c8.332032 0 15.089844-6.757813 15.089844-15.089844v-73.21875c0-8.335937-6.757812-15.089844-15.089844-15.089844zm0 0"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m471.8125 0h-223.597656v172.042969h238.683594v-158.324219c0-7.578125-6.753907-13.71875-15.085938-13.71875zm0 0",
    fill: "#2a4bd8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m248.214844 161.867188h238.683594v189.230468h-238.683594zm0 0",
    fill: "#e53535"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m305.050781 512c8.332031 0 15.089844-6.742188 15.089844-15.0625v-481.875c0-8.320312-6.757813-15.0625-15.089844-15.0625h-128.761719v512zm0 0",
    fill: "#ffbe69"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m176.289062 192.390625h143.851563v126.75h-143.851563zm0 0",
    fill: "#ff9852"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m248.214844 166.238281c-8.332032 0-15.089844 6.757813-15.089844 15.089844v46.273437c0 8.332032 6.757812 15.085938 15.089844 15.085938 8.332031 0 15.089844-6.753906 15.089844-15.085938v-46.273437c0-8.332031-6.757813-15.089844-15.089844-15.089844zm0 0",
    fill: "#ff8a33"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m248.214844 0h71.925781v512h-71.925781zm0 0",
    fill: "#f4b04d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m248.214844 192.390625h71.925781v126.75h-71.925781zm0 0",
    fill: "#ff8a33"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m248.214844 166.238281v76.449219c8.332031 0 15.089844-6.753906 15.089844-15.085938v-46.273437c0-8.332031-6.757813-15.089844-15.089844-15.089844zm0 0",
    fill: "#f96e10"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRar);
export default __webpack_public_path__ + "static/media/rar.19d62a9c934ef6f86a221a0da7c80bef.svg";
export { ForwardRef as ReactComponent };